// src/app/core/ui/neitral.ui/button.ts
import React from 'react';
import clsx from 'clsx';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  className,
  children,
  style,
  ...props
}) => {
  return (
    <button
      className={clsx(
        'rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2',
        {
          primary: 'bg-tg-button text-white hover:opacity-90',
          secondary: 'bg-tg-secondary-bg text-tg-text hover:opacity-80',
          ghost: 'bg-transparent text-tg-button hover:bg-tg-secondary-bg',
        }[variant],
        {
          sm: 'px-3 py-1.5 text-sm',
          md: 'px-4 py-2 text-base',
          lg: 'px-6 py-3 text-lg',
        }[size],
        className
      )}
      style={style}
      {...props}
    >
      {children}
    </button>
  );
};